import Image from "@/shared/data-display/image";
import Button, { DeleteButton } from "@/shared/form/button";
import { captureScreen } from "../utils/capture-screen";
import { useTranslations } from "use-intl";
import { ScissorOutlined } from "@ant-design/icons";

type ScreenshotButtonProps = {
  value?: string;
  onChange?: (value?: string) => void;
};

export function ScreenshotButton({ value, onChange }: ScreenshotButtonProps) {
  const t = useTranslations("Feedback");

  const takeScreenshot = async () => {
    const image = await captureScreen();

    if (image) {
      onChange?.(image);
    }
  };

  return (
    <>
      <Button
        onClick={takeScreenshot}
        block
        disabled={!!value}
        icon={<ScissorOutlined />}
      >
        {t("Make screenshot")}
      </Button>

      {value && (
        <div className="mt-2">
          <div className="relative aspect-video rounded-md overflow-hidden">
            <DeleteButton
              size="small"
              shape="circle"
              className="!absolute top-1 right-1 z-10"
              onClick={() => onChange?.(undefined)}
            />
            <Image src={value} />
          </div>
        </div>
      )}
    </>
  );
}
